var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _DuoyunFormItemElement_instances, _DuoyunFormItemElement_type_get, _DuoyunFormItemElement_slotAssignedElement_get, _DuoyunFormItemElement_change, _DuoyunFormItemElement_onChange, _DuoyunFormItemElement_onCheckboxChange, _DuoyunFormItemElement_onTextChangeWithIndex, _DuoyunFormItemElement_onTextCleanWithIndex, _DuoyunFormItemElement_onTextAdd;
var DuoyunFormItemElement_1;
import { adoptedStyle, customElement, attribute, property, boolattribute, refobject, state, part, globalemitter, } from '@mantou/gem/lib/decorators';
import { GemElement, html } from '@mantou/gem/lib/element';
import { createCSSSheet, css } from '@mantou/gem/lib/utils';
import { mediaQuery } from '@mantou/gem/helper/mediaquery';
import { theme } from '../lib/theme';
import { locale } from '../lib/locale';
import './input';
import './pick';
import './button';
import './checkbox';
import './radio';
import './select';
import './help-text';
import './date-pick';
import './date-range-pick';
const formStyle = createCSSSheet(css `
  dy-form {
    display: block;
  }
  dy-form[inline] {
    display: flex;
    flex-wrap: wrap;
    gap: 1em;
  }
  dy-form[inline] dy-form-item {
    position: relative;
    gap: 0.5em;
    align-items: center;
    flex-direction: row;
    flex-grow: 0;
    margin-block-end: 0;
  }
  dy-form[inline] dy-form-item::part(label) {
    margin-block-end: 0;
  }
  dy-form[inline] dy-form-item::part(input) {
    width: 15em;
  }
  dy-form[inline] dy-form-item::part(input),
  dy-form[inline] dy-form-item::part(add) {
    margin-block-start: 0;
  }
  dy-form[inline] dy-form-item::part(tip) {
    position: absolute;
    width: 100%;
    top: 100%;
    left: 0;
  }
  dy-form-item {
    flex-grow: 1;
    margin-block-end: 1.8em;
  }
  dy-form-item[type='checkbox'] {
    flex-grow: 0;
  }
  dy-form-item:where(:--invalid, [data-invalid]) * {
    border-color: ${theme.negativeColor};
  }
  dy-form-item-inline-group {
    display: flex;
    gap: 1em;
  }
  @media ${mediaQuery.PHONE} {
    dy-form-item-inline-group {
      display: contents;
    }
  }
`);
/**
 * @customElement dy-form
 * @attr inline
 */
let DuoyunFormElement = class DuoyunFormElement extends GemElement {
    constructor() {
        super({ isLight: true });
        this.internals.role = 'form';
        this.addEventListener('itemchange', (evt) => {
            evt.stopPropagation();
            const { name, value } = evt.detail;
            this.change({ ...this.data, [name]: value });
        });
    }
    get items() {
        return [...this.querySelectorAll('dy-form-item')];
    }
    get elements() {
        const target = {};
        return new Proxy(target, {
            get: (_, p) => {
                return this.querySelector(`dy-form-item[name=${p}]`);
            },
        });
    }
    get data() {
        const data = {};
        this.items.forEach((item) => {
            if (!item.name)
                return;
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            Object.assign(data, { [item.name]: item.data });
        });
        return data;
    }
    async valid() {
        let valid = true;
        for await (const item of this.items) {
            valid = (await item.valid()) && valid;
        }
        return valid;
    }
    clearInvalidMessage() {
        this.items.forEach((e) => e.clearInvalidMessage());
    }
};
__decorate([
    boolattribute
], DuoyunFormElement.prototype, "inline", void 0);
__decorate([
    globalemitter
], DuoyunFormElement.prototype, "change", void 0);
DuoyunFormElement = __decorate([
    customElement('dy-form'),
    adoptedStyle(formStyle)
], DuoyunFormElement);
export { DuoyunFormElement };
/**
 * @customElement dy-form-item-inline-group
 */
let DuoyunFormItemInlineGroupElement = class DuoyunFormItemInlineGroupElement extends GemElement {
    constructor() {
        super({ isLight: true });
    }
};
DuoyunFormItemInlineGroupElement = __decorate([
    customElement('dy-form-item-inline-group')
], DuoyunFormItemInlineGroupElement);
export { DuoyunFormItemInlineGroupElement };
const formItemStyle = createCSSSheet(css `
  :host {
    display: flex;
    flex-direction: column;
  }
  :host([required]) .label::after {
    content: '＊';
  }
  :host([hidden]) {
    display: none;
  }
  .label {
    font-size: 0.875em;
    line-height: 1.2;
    margin-bottom: 0.4em;
    color: ${theme.describeColor};
  }
  .label:empty {
    display: none;
  }
  :host(:where(:--invalid, [data-invalid])) .input {
    border-color: ${theme.negativeColor};
  }
  .input {
    width: 100%;
    flex-grow: 1;
    flex-shrink: 1;
  }
  .input + .input,
  .footer {
    margin-top: 10px;
  }
  :host([type='checkbox']) {
    flex-direction: row;
    align-items: center;
  }
  :host([type='checkbox']) .lable {
    flex-direction: row;
    align-items: center;
    margin-bottom: 0;
  }
`);
/**
 * @customElement dy-form-item
 * @attr type
 * @attr multiple
 * @attr name
 * @attr label
 * @attr placeholder
 * @attr required
 * @attr checked
 * @attr autofocus
 * @attr disabled
 * @attr searchable
 * @attr clearable
 */
let DuoyunFormItemElement = DuoyunFormItemElement_1 = class DuoyunFormItemElement extends GemElement {
    constructor() {
        super();
        _DuoyunFormItemElement_instances.add(this);
        this.state = {};
        _DuoyunFormItemElement_change.set(this, (value) => {
            if (this.name) {
                this.itemchange({ name: this.name, value });
            }
        });
        _DuoyunFormItemElement_onChange.set(this, (evt) => {
            evt.stopPropagation();
            __classPrivateFieldGet(this, _DuoyunFormItemElement_change, "f").call(this, evt.detail);
        });
        _DuoyunFormItemElement_onCheckboxChange.set(this, (evt) => {
            evt.stopPropagation();
            __classPrivateFieldGet(this, _DuoyunFormItemElement_change, "f").call(this, this.value ? (evt.detail ? this.value : '') : evt.detail);
        });
        _DuoyunFormItemElement_onTextChangeWithIndex.set(this, (evt, index) => {
            evt.stopPropagation();
            const value = (this.value || []);
            __classPrivateFieldGet(this, _DuoyunFormItemElement_change, "f").call(this, [...value.slice(0, index), evt.detail, ...value.slice(index + 1)]);
        });
        _DuoyunFormItemElement_onTextCleanWithIndex.set(this, async (index) => {
            __classPrivateFieldGet(this, _DuoyunFormItemElement_change, "f").call(this, (this.value || []).filter((_, i) => i !== index));
        });
        _DuoyunFormItemElement_onTextAdd.set(this, async () => {
            __classPrivateFieldGet(this, _DuoyunFormItemElement_change, "f").call(this, [...(this.value || []), '']);
        });
        this.mounted = () => {
            this.effect(([value]) => {
                this.clearInvalidMessage();
                if (__classPrivateFieldGet(this, _DuoyunFormItemElement_instances, "a", _DuoyunFormItemElement_type_get) === 'slot') {
                    const ele = __classPrivateFieldGet(this, _DuoyunFormItemElement_instances, "a", _DuoyunFormItemElement_slotAssignedElement_get);
                    if (ele)
                        ele.value = value;
                }
            }, () => [this.value, this.checked]);
            this.effect(() => {
                this.invalid = !!this.state.invalidMessage;
            }, () => [this.state.invalidMessage]);
        };
        this.render = () => {
            var _a;
            const { invalidMessage } = this.state;
            return html `
      ${__classPrivateFieldGet(this, _DuoyunFormItemElement_instances, "a", _DuoyunFormItemElement_type_get) === 'checkbox'
                ? ''
                : html `<div class="label" part=${DuoyunFormItemElement_1.label} @click=${() => this.focus()}>${this.label}</div>`}
      ${__classPrivateFieldGet(this, _DuoyunFormItemElement_instances, "a", _DuoyunFormItemElement_type_get) === 'select'
                ? html `
            <dy-select
              ?disabled=${this.disabled}
              ?searchable=${this.searchable}
              class="input"
              part=${DuoyunFormItemElement_1.input}
              @change=${__classPrivateFieldGet(this, _DuoyunFormItemElement_onChange, "f")}
              .multiple=${this.multiple}
              .adder=${this.adder}
              .value=${this.value}
              .placeholder=${this.placeholder}
              .options=${this.dataList}
              .renderLabel=${this.renderLabel}
            ></dy-select>
          `
                : __classPrivateFieldGet(this, _DuoyunFormItemElement_instances, "a", _DuoyunFormItemElement_type_get) === 'date'
                    ? html `
            <dy-date-pick
              class="input"
              @change=${__classPrivateFieldGet(this, _DuoyunFormItemElement_onChange, "f")}
              @clear=${(evt) => evt.target.change(undefined)}
              ?disabled=${this.disabled}
              .value=${this.value}
              .time=${this.time}
              .placeholder=${this.placeholder}
              .clearable=${!this.required}
            >
            </dy-date-pick>
          `
                    : __classPrivateFieldGet(this, _DuoyunFormItemElement_instances, "a", _DuoyunFormItemElement_type_get) === 'date-range'
                        ? html `
            <dy-date-range-pick
              class="input"
              @change=${__classPrivateFieldGet(this, _DuoyunFormItemElement_onChange, "f")}
              @clear=${(evt) => evt.target.change(undefined)}
              ?disabled=${this.disabled}
              .value=${this.value}
              .placeholder=${this.placeholder}
              .clearable=${!this.required}
            >
            </dy-date-range-pick>
          `
                        : __classPrivateFieldGet(this, _DuoyunFormItemElement_instances, "a", _DuoyunFormItemElement_type_get) === 'pick'
                            ? html `
            <dy-pick
              ?disabled=${this.disabled}
              class="input"
              part=${DuoyunFormItemElement_1.input}
              @change=${__classPrivateFieldGet(this, _DuoyunFormItemElement_onChange, "f")}
              .multiple=${this.multiple}
              .value=${this.value}
              .fit=${true}
              .placeholder=${this.placeholder}
              .options=${this.dataList}
            ></dy-pick>
          `
                            : __classPrivateFieldGet(this, _DuoyunFormItemElement_instances, "a", _DuoyunFormItemElement_type_get) === 'checkbox'
                                ? html `
            <dy-checkbox
              @change=${__classPrivateFieldGet(this, _DuoyunFormItemElement_onCheckboxChange, "f")}
              ?checked=${this.checked}
              ?disabled=${this.disabled}
              .value=${this.value}
            >
              ${this.label}
            </dy-checkbox>
          `
                                : __classPrivateFieldGet(this, _DuoyunFormItemElement_instances, "a", _DuoyunFormItemElement_type_get) === 'radio-group'
                                    ? html `
            <dy-radio-group
              @change=${__classPrivateFieldGet(this, _DuoyunFormItemElement_onChange, "f")}
              ?disabled=${this.disabled}
              .options=${this.dataList}
              .value=${this.value}
            >
            </dy-radio-group>
          `
                                    : __classPrivateFieldGet(this, _DuoyunFormItemElement_instances, "a", _DuoyunFormItemElement_type_get) === 'checkbox-group'
                                        ? html `
            <dy-checkbox-group
              @change=${__classPrivateFieldGet(this, _DuoyunFormItemElement_onChange, "f")}
              ?disabled=${this.disabled}
              .options=${this.dataList}
              .value=${this.value}
            >
            </dy-checkbox-group>
          `
                                        : this.name && __classPrivateFieldGet(this, _DuoyunFormItemElement_instances, "a", _DuoyunFormItemElement_type_get) !== 'slot'
                                            ? this.multiple
                                                ? html `
              ${(_a = this.value) === null || _a === void 0 ? void 0 : _a.map((value, index) => html `
                    <dy-input
                      class="input"
                      part=${DuoyunFormItemElement_1.input}
                      ?disabled=${this.disabled}
                      .placeholder=${this.placeholder}
                      @change=${(evt) => __classPrivateFieldGet(this, _DuoyunFormItemElement_onTextChangeWithIndex, "f").call(this, evt, index)}
                      @clear=${() => __classPrivateFieldGet(this, _DuoyunFormItemElement_onTextCleanWithIndex, "f").call(this, index)}
                      .autofocus=${this.autofocus}
                      .clearable=${true}
                      .alwayclearable=${true}
                      .dataList=${this.dataList}
                      .value=${value}
                    ></dy-input>
                  `)}
              <div class="footer" part=${DuoyunFormItemElement_1.add}>
                <dy-button .color=${'cancel'} @click=${__classPrivateFieldGet(this, _DuoyunFormItemElement_onTextAdd, "f")}>+</dy-button>
              </div>
            `
                                                : html `
              <dy-input
                class="input"
                part=${DuoyunFormItemElement_1.input}
                name=${this.name}
                type=${__classPrivateFieldGet(this, _DuoyunFormItemElement_instances, "a", _DuoyunFormItemElement_type_get)}
                ?disabled=${this.disabled}
                @change=${__classPrivateFieldGet(this, _DuoyunFormItemElement_onChange, "f")}
                @clear=${(evt) => evt.target.change('')}
                .autofocus=${this.autofocus}
                .clearable=${this.clearable}
                .value=${this.value}
                .placeholder=${this.placeholder}
                .required=${this.required}
                .dataList=${this.dataList}
              ></dy-input>
            `
                                            : ''}
      <slot ref=${this.slotRef.ref}></slot>
      ${invalidMessage
                ? html `
            <dy-help-text class="tip" part=${DuoyunFormItemElement_1.tip} status="negative">
              ${invalidMessage}
            </dy-help-text>
          `
                : ''}
    `;
        };
        this.addEventListener('change', (evt) => {
            if (!this.name) {
                evt.stopPropagation();
            }
            if (__classPrivateFieldGet(this, _DuoyunFormItemElement_instances, "a", _DuoyunFormItemElement_type_get) === 'slot') {
                __classPrivateFieldGet(this, _DuoyunFormItemElement_change, "f").call(this, evt.detail);
            }
        });
    }
    get data() {
        const { value, checked } = this;
        if (__classPrivateFieldGet(this, _DuoyunFormItemElement_instances, "a", _DuoyunFormItemElement_type_get) === 'checkbox') {
            return value ? (checked ? value : '') : checked;
        }
        return value;
    }
    focus() {
        var _a;
        const input = ((_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('dy-input')) || this.querySelector('dy-input');
        input === null || input === void 0 ? void 0 : input.focus();
    }
    clearInvalidMessage() {
        this.setState({ invalidMessage: undefined });
    }
    async valid() {
        const rules = [...(this.rules || [])];
        if (this.required && !rules.find((e) => 'required' in e)) {
            rules.push({ required: true });
        }
        for await (const rule of rules) {
            let invalidMessage = '';
            if (rule.required && (!this.value || (Array.isArray(this.value) && !this.value.length))) {
                invalidMessage = rule.message || locale.requiredMeg;
            }
            else if (rule.pattern && !new RegExp(rule.pattern).test(String(this.value || ''))) {
                invalidMessage = rule.message || locale.ptternMsg;
            }
            else if (rule.validator) {
                try {
                    await rule.validator(this.value);
                }
                catch (err) {
                    if (err instanceof Error) {
                        invalidMessage = err.message;
                    }
                    else {
                        invalidMessage = err;
                    }
                }
            }
            if (invalidMessage) {
                this.setState({ invalidMessage });
                return false;
            }
        }
        return true;
    }
};
_DuoyunFormItemElement_change = new WeakMap(), _DuoyunFormItemElement_onChange = new WeakMap(), _DuoyunFormItemElement_onCheckboxChange = new WeakMap(), _DuoyunFormItemElement_onTextChangeWithIndex = new WeakMap(), _DuoyunFormItemElement_onTextCleanWithIndex = new WeakMap(), _DuoyunFormItemElement_onTextAdd = new WeakMap(), _DuoyunFormItemElement_instances = new WeakSet(), _DuoyunFormItemElement_type_get = function _DuoyunFormItemElement_type_get() {
    return this.type || 'text';
}, _DuoyunFormItemElement_slotAssignedElement_get = function _DuoyunFormItemElement_slotAssignedElement_get() {
    return this.slotRef.element.assignedElements()[0];
};
__decorate([
    attribute
], DuoyunFormItemElement.prototype, "type", void 0);
__decorate([
    boolattribute
], DuoyunFormItemElement.prototype, "multiple", void 0);
__decorate([
    attribute
], DuoyunFormItemElement.prototype, "name", void 0);
__decorate([
    attribute
], DuoyunFormItemElement.prototype, "label", void 0);
__decorate([
    attribute
], DuoyunFormItemElement.prototype, "placeholder", void 0);
__decorate([
    boolattribute
], DuoyunFormItemElement.prototype, "required", void 0);
__decorate([
    boolattribute
], DuoyunFormItemElement.prototype, "checked", void 0);
__decorate([
    boolattribute
], DuoyunFormItemElement.prototype, "autofocus", void 0);
__decorate([
    boolattribute
], DuoyunFormItemElement.prototype, "disabled", void 0);
__decorate([
    boolattribute
], DuoyunFormItemElement.prototype, "searchable", void 0);
__decorate([
    boolattribute
], DuoyunFormItemElement.prototype, "clearable", void 0);
__decorate([
    boolattribute
], DuoyunFormItemElement.prototype, "time", void 0);
__decorate([
    state
], DuoyunFormItemElement.prototype, "invalid", void 0);
__decorate([
    property
], DuoyunFormItemElement.prototype, "value", void 0);
__decorate([
    property
], DuoyunFormItemElement.prototype, "renderLabel", void 0);
__decorate([
    property
], DuoyunFormItemElement.prototype, "rules", void 0);
__decorate([
    property
], DuoyunFormItemElement.prototype, "dataList", void 0);
__decorate([
    property
], DuoyunFormItemElement.prototype, "adder", void 0);
__decorate([
    globalemitter
], DuoyunFormItemElement.prototype, "itemchange", void 0);
__decorate([
    refobject
], DuoyunFormItemElement.prototype, "slotRef", void 0);
__decorate([
    part
], DuoyunFormItemElement, "label", void 0);
__decorate([
    part
], DuoyunFormItemElement, "tip", void 0);
__decorate([
    part
], DuoyunFormItemElement, "input", void 0);
__decorate([
    part
], DuoyunFormItemElement, "add", void 0);
DuoyunFormItemElement = DuoyunFormItemElement_1 = __decorate([
    customElement('dy-form-item'),
    adoptedStyle(formItemStyle)
], DuoyunFormItemElement);
export { DuoyunFormItemElement };
//# sourceMappingURL=form.js.map